import cn from 'classnames';

import { IConDefaultType } from '../types';

export enum ShampooIconVariant {
  OLDBIE_4 = 'oldbie_4',
  OLDBIE_3 = 'oldbie_3',
  OLDBIE_2 = 'oldbie_2',
  OLDBIE_1 = 'oldbie_1',
  OLDBIE_0 = 'oldbie_0',
  OLDBIE_4_GAUGE = 'oldbie_4_gauge',
  OLDBIE_3_GAUGE = 'oldbie_3_gauge',
  OLDBIE_2_GAUGE = 'oldbie_2_gauge',
  OLDBIE_1_GAUGE = 'oldbie_1_gauge',
  OLDBIE_0_GAUGE = 'oldbie_0_gauge',

  // 슈퍼샴푸
  NEWBIE_4 = 'newbie_4',
  NEWBIE_3 = 'newbie_3',
  NEWBIE_2 = 'newbie_2',
  NEWBIE_1 = 'newbie_1',
  NEWBIE_0 = 'newbie_0',
  NEWBIE_4_GAUGE = 'newbie_4_gauge',
  NEWBIE_3_GAUGE = 'newbie_3_gauge',
  NEWBIE_2_GAUGE = 'newbie_2_gauge',
  NEWBIE_1_GAUGE = 'newbie_1_gauge',
  NEWBIE_0_GAUGE = 'newbie_0_gauge',
  NEWBIE_REFILL = 'newbie_refill',

  // 하이퍼 샴푸
  HYPER_4 = 'hyper_4',
  HYPER_3 = 'hyper_3',
  HYPER_2 = 'hyper_2',
  HYPER_1 = 'hyper_1',
  HYPER_0 = 'hyper_0',
  HYPER_4_GAUGE = 'hyper_4_gauge',
  HYPER_3_GAUGE = 'hyper_3_gauge',
  HYPER_2_GAUGE = 'hyper_2_gauge',
  HYPER_1_GAUGE = 'hyper_1_gauge',
  HYPER_0_GAUGE = 'hyper_0_gauge',
  HYPER_REFILL = 'hyper_refill',

  // 드림 포션 (Tingle)
  DREAM_4 = 'dream_4',
  DREAM_3 = 'dream_3',
  DREAM_2 = 'dream_2',
  DREAM_1 = 'dream_1',
  DREAM_0 = 'dream_0',
  DREAM_4_GAUGE = 'dream_4_gauge',
  DREAM_3_GAUGE = 'dream_3_gauge',
  DREAM_2_GAUGE = 'dream_2_gauge',
  DREAM_1_GAUGE = 'dream_1_gauge',
  DREAM_0_GAUGE = 'dream_0_gauge',
  DREAM_REFILL = 'dream_refill',

  // 매직 포션 (Tingle)
  MAGIC_4 = 'magic_4',
  MAGIC_3 = 'magic_3',
  MAGIC_2 = 'magic_2',
  MAGIC_1 = 'magic_1',
  MAGIC_0 = 'magic_0',
  MAGIC_4_GAUGE = 'magic_4_gauge',
  MAGIC_3_GAUGE = 'magic_3_gauge',
  MAGIC_2_GAUGE = 'magic_2_gauge',
  MAGIC_1_GAUGE = 'magic_1_gauge',
  MAGIC_0_GAUGE = 'magic_0_gauge',
  MAGIC_REFILL = 'magic_refill',

  ERROR = 'error',
  LOADING = 'loading',
  ERROR_GAUGE = 'error_gauge',
  LOADING_GAUGE = 'loading_gauge',
}

export interface IShampooIconProps extends IConDefaultType {
  variant?: ShampooIconVariant;
}

function ShampooIcon({
  className,
  size = 30,
  rotate,
  flip,
  variant = ShampooIconVariant.OLDBIE_4,
  style,
}: IShampooIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
        ...style,
      }}
    >
      {variant === ShampooIconVariant.OLDBIE_4 && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.6167 3.23247C9.6167 2.89697 9.88855 2.625 10.2239 2.625H15.3545H15.5476L17.1189 3.73695C17.3927 3.93069 17.4577 4.30978 17.264 4.58369C17.0704 4.8576 16.6915 4.92259 16.4177 4.72885L15.1615 3.83994H12.6722V5.08712H13.7814C14.0944 5.08712 14.3481 5.34096 14.3481 5.65409V6.64513C16.0718 6.97153 17.3754 8.48638 17.3754 10.3058V19.1876C17.3754 20.3957 16.3965 21.375 15.1889 21.375H8.81143C7.6039 21.375 6.625 20.3957 6.625 19.1875V10.3058C6.625 8.4285 8.01282 6.87546 9.81802 6.61761V5.65409C9.81802 5.34096 10.0717 5.08712 10.3847 5.08712H11.4578V3.83994H10.2239C9.88855 3.83994 9.6167 3.56797 9.6167 3.23247Z"
            fill="#E0F4FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.6167 3.23247C9.6167 2.89697 9.88855 2.625 10.2239 2.625H15.3545H15.5476L17.1189 3.73695C17.3927 3.93069 17.4577 4.30978 17.264 4.58369C17.0704 4.8576 16.6915 4.92259 16.4177 4.72885L15.1615 3.83994H12.6722V5.08712H13.7814C14.0944 5.08712 14.3481 5.34096 14.3481 5.65409V6.64513C16.0718 6.97153 17.3754 8.48638 17.3754 10.3058V19.1876C17.3754 20.3957 16.3965 21.375 15.1889 21.375H8.81143C7.6039 21.375 6.625 20.3957 6.625 19.1875V10.3058C6.625 8.4285 8.01282 6.87546 9.81802 6.61761V5.65409C9.81802 5.34096 10.0717 5.08712 10.3847 5.08712H11.4578V3.83994H10.2239C9.88855 3.83994 9.6167 3.56797 9.6167 3.23247Z"
            fill="url(#paint0_linear_2537_82522)"
          />
          <path
            d="M14.5071 11.45C14.9035 11.45 15.2265 11.7715 15.2265 12.1702C15.2265 12.5671 14.9035 12.8905 14.5071 12.8905C14.1106 12.8905 13.7876 12.5671 13.7876 12.1702C13.7876 11.7733 14.1106 11.45 14.5071 11.45Z"
            fill="#00607B"
          />
          <path
            d="M9.4929 11.45C9.88933 11.45 10.2124 11.7715 10.2124 12.1702C10.2124 12.5671 9.88933 12.8905 9.4929 12.8905C9.09646 12.8905 8.77344 12.5671 8.77344 12.1702C8.77344 11.7733 9.09646 11.45 9.4929 11.45Z"
            fill="#00607B"
          />
          <path
            d="M12.9305 12.3503C12.9305 12.8666 12.512 13.2874 11.9945 13.2874H11.9926C11.4769 13.2874 11.0566 12.8685 11.0566 12.3503H12.9305Z"
            fill="#00607B"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.7459 2L17.4794 3.22669C18.0348 3.61975 18.1666 4.38888 17.7738 4.94459C17.3809 5.5003 16.6121 5.63216 16.0567 5.2391L14.9626 4.46492H13.8634C14.483 4.50722 14.9725 5.02346 14.9725 5.65409V6.15971C16.7281 6.71944 17.9998 8.3635 17.9998 10.3058V19.1875C17.9998 20.7408 16.7412 22 15.1886 22H8.81113C7.25858 22 6 20.7408 6 19.1875V10.3058C6 8.30304 7.3521 6.61711 9.19302 6.11049V5.65409C9.19302 5.02346 9.68252 4.50722 10.3021 4.46492H10.2236C9.54323 4.46492 8.9917 3.91313 8.9917 3.23246C8.9917 2.55179 9.54323 2 10.2236 2H15.7459ZM11.4575 3.83993V5.08711H10.3844C10.0714 5.08711 9.81772 5.34096 9.81772 5.65409V6.6176C8.01251 6.87545 6.62469 8.42849 6.62469 10.3058V19.1875C6.62469 20.3956 7.60359 21.375 8.81113 21.375H15.1886C16.3962 21.375 17.3751 20.3956 17.3751 19.1875V10.3058C17.3751 8.48637 16.0715 6.97152 14.3478 6.64512V5.65409C14.3478 5.34096 14.0941 5.08711 13.7811 5.08711H12.6719V3.83993H15.1612L16.4174 4.72884C16.6912 4.92258 17.0701 4.85759 17.2637 4.58368C17.4574 4.30978 17.3924 3.93068 17.1186 3.73694L15.5473 2.62499H10.2236C9.88824 2.62499 9.6164 2.89696 9.6164 3.23246C9.6164 3.56796 9.88824 3.83993 10.2236 3.83993H11.4575Z"
            fill="#0087AD"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2537_82522"
              x1="8.5001"
              y1="4.80674"
              x2="20.1297"
              y2="16.5416"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#A8F5FF" />
              <stop offset="1" stopColor="#00C3DD" />
            </linearGradient>
          </defs>
        </svg>
      )}
      {variant === ShampooIconVariant.OLDBIE_3 && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.6167 3.23247C9.6167 2.89697 9.88855 2.625 10.2239 2.625H15.3545H15.5476L17.1189 3.73695C17.3927 3.93069 17.4577 4.30978 17.264 4.58369C17.0704 4.8576 16.6915 4.92259 16.4177 4.72885L15.1615 3.83994H12.6722V5.08712H13.7814C14.0944 5.08712 14.3481 5.34096 14.3481 5.65409V6.64513C16.0718 6.97153 17.3754 8.48638 17.3754 10.3058V19.1876C17.3754 20.3957 16.3965 21.375 15.1889 21.375H8.81143C7.6039 21.375 6.625 20.3957 6.625 19.1875V10.3058C6.625 8.4285 8.01282 6.87546 9.81802 6.61761V5.65409C9.81802 5.34096 10.0717 5.08712 10.3847 5.08712H11.4578V3.83994H10.2239C9.88855 3.83994 9.6167 3.56797 9.6167 3.23247Z"
            fill="url(#paint0_linear_2537_82534)"
          />
          <mask
            id="mask0_2537_82534"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="6"
            y="2"
            width="12"
            height="20"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.6167 3.23247C9.6167 2.89697 9.88855 2.625 10.2239 2.625H15.3545H15.5476L17.1189 3.73695C17.3927 3.93069 17.4577 4.30978 17.264 4.58369C17.0704 4.8576 16.6915 4.92259 16.4177 4.72885L15.1615 3.83994H12.6722V5.08712H13.7814C14.0944 5.08712 14.3481 5.34096 14.3481 5.65409V6.64513C16.0718 6.97153 17.3754 8.48638 17.3754 10.3058V19.1876C17.3754 20.3957 16.3965 21.375 15.1889 21.375H8.81143C7.6039 21.375 6.625 20.3957 6.625 19.1875V10.3058C6.625 8.4285 8.01282 6.87546 9.81802 6.61761V5.65409C9.81802 5.34096 10.0717 5.08712 10.3847 5.08712H11.4578V3.83994H10.2239C9.88855 3.83994 9.6167 3.56797 9.6167 3.23247Z"
              fill="#E0F4FF"
            />
          </mask>
          <g mask="url(#mask0_2537_82534)">
            <rect width="13.0059" height="7" transform="matrix(1 0 0 -1 5.49707 8.99609)" fill="#E0F4FF" />
          </g>
          <path
            d="M14.5071 11.45C14.9035 11.45 15.2265 11.7715 15.2265 12.1702C15.2265 12.5671 14.9035 12.8905 14.5071 12.8905C14.1106 12.8905 13.7876 12.5671 13.7876 12.1702C13.7876 11.7733 14.1106 11.45 14.5071 11.45Z"
            fill="#00607B"
          />
          <path
            d="M9.4929 11.45C9.88933 11.45 10.2124 11.7715 10.2124 12.1702C10.2124 12.5671 9.88933 12.8905 9.4929 12.8905C9.09646 12.8905 8.77344 12.5671 8.77344 12.1702C8.77344 11.7733 9.09646 11.45 9.4929 11.45Z"
            fill="#00607B"
          />
          <path
            d="M12.9305 12.3503C12.9305 12.8666 12.512 13.2874 11.9945 13.2874H11.9926C11.4769 13.2874 11.0566 12.8685 11.0566 12.3503H12.9305Z"
            fill="#00607B"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.7459 2L17.4794 3.22669C18.0348 3.61975 18.1666 4.38888 17.7738 4.94459C17.3809 5.5003 16.6121 5.63216 16.0567 5.2391L14.9626 4.46492H13.8634C14.483 4.50722 14.9725 5.02346 14.9725 5.65409V6.15971C16.7281 6.71944 17.9998 8.3635 17.9998 10.3058V19.1875C17.9998 20.7408 16.7412 22 15.1886 22H8.81113C7.25858 22 6 20.7408 6 19.1875V10.3058C6 8.30304 7.3521 6.61711 9.19302 6.11049V5.65409C9.19302 5.02346 9.68252 4.50722 10.3021 4.46492H10.2236C9.54323 4.46492 8.9917 3.91313 8.9917 3.23246C8.9917 2.55179 9.54323 2 10.2236 2H15.7459ZM11.4575 3.83993V5.08711H10.3844C10.0714 5.08711 9.81772 5.34096 9.81772 5.65409V6.6176C8.01251 6.87545 6.62469 8.42849 6.62469 10.3058V19.1875C6.62469 20.3956 7.60359 21.375 8.81113 21.375H15.1886C16.3962 21.375 17.3751 20.3956 17.3751 19.1875V10.3058C17.3751 8.48637 16.0715 6.97152 14.3478 6.64512V5.65409C14.3478 5.34096 14.0941 5.08711 13.7811 5.08711H12.6719V3.83993H15.1612L16.4174 4.72884C16.6912 4.92258 17.0701 4.85759 17.2637 4.58368C17.4574 4.30978 17.3924 3.93068 17.1186 3.73694L15.5473 2.62499H10.2236C9.88824 2.62499 9.6164 2.89696 9.6164 3.23246C9.6164 3.56796 9.88824 3.83993 10.2236 3.83993H11.4575Z"
            fill="#0087AD"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2537_82534"
              x1="8.5001"
              y1="4.80674"
              x2="20.1297"
              y2="16.5416"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#A8F5FF" />
              <stop offset="1" stopColor="#00C3DD" />
            </linearGradient>
          </defs>
        </svg>
      )}
      {variant === ShampooIconVariant.OLDBIE_2 && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.6167 3.23247C9.6167 2.89697 9.88855 2.625 10.2239 2.625H15.3545H15.5476L17.1189 3.73695C17.3927 3.93069 17.4577 4.30978 17.264 4.58369C17.0704 4.8576 16.6915 4.92259 16.4177 4.72885L15.1615 3.83994H12.6722V5.08712H13.7814C14.0944 5.08712 14.3481 5.34096 14.3481 5.65409V6.64513C16.0718 6.97153 17.3754 8.48638 17.3754 10.3058V19.1876C17.3754 20.3957 16.3965 21.375 15.1889 21.375H8.81143C7.6039 21.375 6.625 20.3957 6.625 19.1875V10.3058C6.625 8.4285 8.01282 6.87546 9.81802 6.61761V5.65409C9.81802 5.34096 10.0717 5.08712 10.3847 5.08712H11.4578V3.83994H10.2239C9.88855 3.83994 9.6167 3.56797 9.6167 3.23247Z"
            fill="url(#paint0_linear_2537_82537)"
          />
          <mask
            id="mask0_2537_82537"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="6"
            y="2"
            width="12"
            height="20"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.6167 3.23247C9.6167 2.89697 9.88855 2.625 10.2239 2.625H15.3545H15.5476L17.1189 3.73695C17.3927 3.93069 17.4577 4.30978 17.264 4.58369C17.0704 4.8576 16.6915 4.92259 16.4177 4.72885L15.1615 3.83994H12.6722V5.08712H13.7814C14.0944 5.08712 14.3481 5.34096 14.3481 5.65409V6.64513C16.0718 6.97153 17.3754 8.48638 17.3754 10.3058V19.1876C17.3754 20.3957 16.3965 21.375 15.1889 21.375H8.81143C7.6039 21.375 6.625 20.3957 6.625 19.1875V10.3058C6.625 8.4285 8.01282 6.87546 9.81802 6.61761V5.65409C9.81802 5.34096 10.0717 5.08712 10.3847 5.08712H11.4578V3.83994H10.2239C9.88855 3.83994 9.6167 3.56797 9.6167 3.23247Z"
              fill="#E0F4FF"
            />
          </mask>
          <g mask="url(#mask0_2537_82537)">
            <rect width="13.0059" height="12.9224" transform="matrix(1 0 0 -1 5.49707 13.8936)" fill="#E0F4FF" />
          </g>
          <path
            d="M14.5071 11.45C14.9035 11.45 15.2265 11.7715 15.2265 12.1702C15.2265 12.5671 14.9035 12.8905 14.5071 12.8905C14.1106 12.8905 13.7876 12.5671 13.7876 12.1702C13.7876 11.7733 14.1106 11.45 14.5071 11.45Z"
            fill="#00607B"
          />
          <path
            d="M9.4929 11.45C9.88933 11.45 10.2124 11.7715 10.2124 12.1702C10.2124 12.5671 9.88933 12.8905 9.4929 12.8905C9.09646 12.8905 8.77344 12.5671 8.77344 12.1702C8.77344 11.7733 9.09646 11.45 9.4929 11.45Z"
            fill="#00607B"
          />
          <path
            d="M12.9305 12.3503C12.9305 12.8666 12.512 13.2874 11.9945 13.2874H11.9926C11.4769 13.2874 11.0566 12.8685 11.0566 12.3503H12.9305Z"
            fill="#00607B"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.7459 2L17.4794 3.22669C18.0348 3.61975 18.1666 4.38888 17.7738 4.94459C17.3809 5.5003 16.6121 5.63216 16.0567 5.2391L14.9626 4.46492H13.8634C14.483 4.50722 14.9725 5.02346 14.9725 5.65409V6.15971C16.7281 6.71944 17.9998 8.3635 17.9998 10.3058V19.1875C17.9998 20.7408 16.7412 22 15.1886 22H8.81113C7.25858 22 6 20.7408 6 19.1875V10.3058C6 8.30304 7.3521 6.61711 9.19302 6.11049V5.65409C9.19302 5.02346 9.68252 4.50722 10.3021 4.46492H10.2236C9.54323 4.46492 8.9917 3.91313 8.9917 3.23246C8.9917 2.55179 9.54323 2 10.2236 2H15.7459ZM11.4575 3.83993V5.08711H10.3844C10.0714 5.08711 9.81772 5.34096 9.81772 5.65409V6.6176C8.01251 6.87545 6.62469 8.42849 6.62469 10.3058V19.1875C6.62469 20.3956 7.60359 21.375 8.81113 21.375H15.1886C16.3962 21.375 17.3751 20.3956 17.3751 19.1875V10.3058C17.3751 8.48637 16.0715 6.97152 14.3478 6.64512V5.65409C14.3478 5.34096 14.0941 5.08711 13.7811 5.08711H12.6719V3.83993H15.1612L16.4174 4.72884C16.6912 4.92258 17.0701 4.85759 17.2637 4.58368C17.4574 4.30978 17.3924 3.93068 17.1186 3.73694L15.5473 2.62499H10.2236C9.88824 2.62499 9.6164 2.89696 9.6164 3.23246C9.6164 3.56796 9.88824 3.83993 10.2236 3.83993H11.4575Z"
            fill="#0087AD"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2537_82537"
              x1="8.5001"
              y1="4.80674"
              x2="20.1297"
              y2="16.5416"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#A8F5FF" />
              <stop offset="1" stopColor="#00C3DD" />
            </linearGradient>
          </defs>
        </svg>
      )}
      {variant === ShampooIconVariant.OLDBIE_1 && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.6167 3.23247C9.6167 2.89697 9.88855 2.625 10.2239 2.625H15.3545H15.5476L17.1189 3.73695C17.3927 3.93069 17.4577 4.30978 17.264 4.58369C17.0704 4.8576 16.6915 4.92259 16.4177 4.72885L15.1615 3.83994H12.6722V5.08712H13.7814C14.0944 5.08712 14.3481 5.34096 14.3481 5.65409V6.64513C16.0718 6.97153 17.3754 8.48638 17.3754 10.3058V19.1876C17.3754 20.3957 16.3965 21.375 15.1889 21.375H8.81143C7.6039 21.375 6.625 20.3957 6.625 19.1875V10.3058C6.625 8.4285 8.01282 6.87546 9.81802 6.61761V5.65409C9.81802 5.34096 10.0717 5.08712 10.3847 5.08712H11.4578V3.83994H10.2239C9.88855 3.83994 9.6167 3.56797 9.6167 3.23247Z"
            fill="url(#paint0_linear_2537_82548)"
          />
          <mask
            id="mask0_2537_82548"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="6"
            y="2"
            width="12"
            height="20"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.6167 3.23247C9.6167 2.89697 9.88855 2.625 10.2239 2.625H15.3545H15.5476L17.1189 3.73695C17.3927 3.93069 17.4577 4.30978 17.264 4.58369C17.0704 4.8576 16.6915 4.92259 16.4177 4.72885L15.1615 3.83994H12.6722V5.08712H13.7814C14.0944 5.08712 14.3481 5.34096 14.3481 5.65409V6.64513C16.0718 6.97153 17.3754 8.48638 17.3754 10.3058V19.1876C17.3754 20.3957 16.3965 21.375 15.1889 21.375H8.81143C7.6039 21.375 6.625 20.3957 6.625 19.1875V10.3058C6.625 8.4285 8.01282 6.87546 9.81802 6.61761V5.65409C9.81802 5.34096 10.0717 5.08712 10.3847 5.08712H11.4578V3.83994H10.2239C9.88855 3.83994 9.6167 3.56797 9.6167 3.23247Z"
              fill="#E0F4FF"
            />
          </mask>
          <g mask="url(#mask0_2537_82548)">
            <rect width="12.0002" height="16.1875" transform="matrix(1 0 0 -1 6 18.1875)" fill="#E0F4FF" />
          </g>
          <path
            d="M14.5071 11.45C14.9035 11.45 15.2265 11.7715 15.2265 12.1702C15.2265 12.5671 14.9035 12.8905 14.5071 12.8905C14.1106 12.8905 13.7876 12.5671 13.7876 12.1702C13.7876 11.7733 14.1106 11.45 14.5071 11.45Z"
            fill="#00607B"
          />
          <path
            d="M9.4929 11.45C9.88933 11.45 10.2124 11.7715 10.2124 12.1702C10.2124 12.5671 9.88933 12.8905 9.4929 12.8905C9.09646 12.8905 8.77344 12.5671 8.77344 12.1702C8.77344 11.7733 9.09646 11.45 9.4929 11.45Z"
            fill="#00607B"
          />
          <path
            d="M12.9305 12.3503C12.9305 12.8666 12.512 13.2874 11.9945 13.2874H11.9926C11.4769 13.2874 11.0566 12.8685 11.0566 12.3503H12.9305Z"
            fill="#00607B"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.7459 2L17.4794 3.22669C18.0348 3.61975 18.1666 4.38888 17.7738 4.94459C17.3809 5.5003 16.6121 5.63216 16.0567 5.2391L14.9626 4.46492H13.8634C14.483 4.50722 14.9725 5.02346 14.9725 5.65409V6.15971C16.7281 6.71944 17.9998 8.3635 17.9998 10.3058V19.1875C17.9998 20.7408 16.7412 22 15.1886 22H8.81113C7.25858 22 6 20.7408 6 19.1875V10.3058C6 8.30304 7.3521 6.61711 9.19302 6.11049V5.65409C9.19302 5.02346 9.68252 4.50722 10.3021 4.46492H10.2236C9.54323 4.46492 8.9917 3.91313 8.9917 3.23246C8.9917 2.55179 9.54323 2 10.2236 2H15.7459ZM11.4575 3.83993V5.08711H10.3844C10.0714 5.08711 9.81772 5.34096 9.81772 5.65409V6.6176C8.01251 6.87545 6.62469 8.42849 6.62469 10.3058V19.1875C6.62469 20.3956 7.60359 21.375 8.81113 21.375H15.1886C16.3962 21.375 17.3751 20.3956 17.3751 19.1875V10.3058C17.3751 8.48637 16.0715 6.97152 14.3478 6.64512V5.65409C14.3478 5.34096 14.0941 5.08711 13.7811 5.08711H12.6719V3.83993H15.1612L16.4174 4.72884C16.6912 4.92258 17.0701 4.85759 17.2637 4.58368C17.4574 4.30978 17.3924 3.93068 17.1186 3.73694L15.5473 2.62499H10.2236C9.88824 2.62499 9.6164 2.89696 9.6164 3.23246C9.6164 3.56796 9.88824 3.83993 10.2236 3.83993H11.4575Z"
            fill="#0087AD"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2537_82548"
              x1="8.5001"
              y1="4.80674"
              x2="20.1297"
              y2="16.5416"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#A8F5FF" />
              <stop offset="1" stopColor="#00C3DD" />
            </linearGradient>
          </defs>
        </svg>
      )}
      {variant === ShampooIconVariant.OLDBIE_0 && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.6167 3.23247C9.6167 2.89697 9.88855 2.625 10.2239 2.625H15.3545H15.5476L17.1189 3.73695C17.3927 3.93069 17.4577 4.30978 17.264 4.58369C17.0704 4.8576 16.6915 4.92259 16.4177 4.72885L15.1615 3.83994H12.6722V5.08712H13.7814C14.0944 5.08712 14.3481 5.34096 14.3481 5.65409V6.64513C16.0718 6.97153 17.3754 8.48638 17.3754 10.3058V19.1876C17.3754 20.3957 16.3965 21.375 15.1889 21.375H8.81143C7.6039 21.375 6.625 20.3957 6.625 19.1875V10.3058C6.625 8.4285 8.01282 6.87546 9.81802 6.61761V5.65409C9.81802 5.34096 10.0717 5.08712 10.3847 5.08712H11.4578V3.83994H10.2239C9.88855 3.83994 9.6167 3.56797 9.6167 3.23247Z"
            fill="url(#paint0_linear_2537_82559)"
          />
          <mask
            id="mask0_2537_82559"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="6"
            y="2"
            width="12"
            height="20"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.6167 3.23247C9.6167 2.89697 9.88855 2.625 10.2239 2.625H15.3545H15.5476L17.1189 3.73695C17.3927 3.93069 17.4577 4.30978 17.264 4.58369C17.0704 4.8576 16.6915 4.92259 16.4177 4.72885L15.1615 3.83994H12.6722V5.08712H13.7814C14.0944 5.08712 14.3481 5.34096 14.3481 5.65409V6.64513C16.0718 6.97153 17.3754 8.48638 17.3754 10.3058V19.1876C17.3754 20.3957 16.3965 21.375 15.1889 21.375H8.81143C7.6039 21.375 6.625 20.3957 6.625 19.1875V10.3058C6.625 8.4285 8.01282 6.87546 9.81802 6.61761V5.65409C9.81802 5.34096 10.0717 5.08712 10.3847 5.08712H11.4578V3.83994H10.2239C9.88855 3.83994 9.6167 3.56797 9.6167 3.23247Z"
              fill="#E0F4FF"
            />
          </mask>
          <g mask="url(#mask0_2537_82559)">
            <rect width="12.0002" height="19.9995" transform="matrix(1 0 0 -1 6 22)" fill="#E0F4FF" />
          </g>
          <path
            d="M11.0706 13.2593C11.0706 12.7502 11.4891 12.3353 12.0066 12.3353H12.0085C12.5242 12.3353 12.9445 12.7484 12.9445 13.2593L11.0706 13.2593Z"
            fill="#00607B"
          />
          <path
            d="M14.5081 11.4219C14.9045 11.4219 15.2275 11.739 15.2275 12.1322C15.2275 12.5235 14.9045 12.8424 14.5081 12.8424C14.1116 12.8424 13.7886 12.5235 13.7886 12.1322C13.7886 11.7408 14.1116 11.4219 14.5081 11.4219Z"
            fill="#00607B"
          />
          <path
            d="M9.49387 11.4219C9.89031 11.4219 10.2133 11.739 10.2133 12.1322C10.2133 12.5235 9.89031 12.8424 9.49387 12.8424C9.09744 12.8424 8.77441 12.5235 8.77441 12.1322C8.77441 11.7408 9.09744 11.4219 9.49387 11.4219Z"
            fill="#00607B"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.7459 2L17.4794 3.22669C18.0348 3.61975 18.1666 4.38888 17.7738 4.94459C17.3809 5.5003 16.6121 5.63216 16.0567 5.2391L14.9626 4.46492H13.8634C14.483 4.50722 14.9725 5.02346 14.9725 5.65409V6.15971C16.7281 6.71944 17.9998 8.3635 17.9998 10.3058V19.1875C17.9998 20.7408 16.7412 22 15.1886 22H8.81113C7.25858 22 6 20.7408 6 19.1875V10.3058C6 8.30304 7.3521 6.61711 9.19302 6.11049V5.65409C9.19302 5.02346 9.68252 4.50722 10.3021 4.46492H10.2236C9.54323 4.46492 8.9917 3.91313 8.9917 3.23246C8.9917 2.55179 9.54323 2 10.2236 2H15.7459ZM11.4575 3.83993V5.08711H10.3844C10.0714 5.08711 9.81772 5.34096 9.81772 5.65409V6.6176C8.01251 6.87545 6.62469 8.42849 6.62469 10.3058V19.1875C6.62469 20.3956 7.60359 21.375 8.81113 21.375H15.1886C16.3962 21.375 17.3751 20.3956 17.3751 19.1875V10.3058C17.3751 8.48637 16.0715 6.97152 14.3478 6.64512V5.65409C14.3478 5.34096 14.0941 5.08711 13.7811 5.08711H12.6719V3.83993H15.1612L16.4174 4.72884C16.6912 4.92258 17.0701 4.85759 17.2637 4.58368C17.4574 4.30978 17.3924 3.93068 17.1186 3.73694L15.5473 2.62499H10.2236C9.88824 2.62499 9.6164 2.89696 9.6164 3.23246C9.6164 3.56796 9.88824 3.83993 10.2236 3.83993H11.4575Z"
            fill="#0087AD"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2537_82559"
              x1="8.5001"
              y1="4.80674"
              x2="20.1297"
              y2="16.5416"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#A8F5FF" />
              <stop offset="1" stopColor="#00C3DD" />
            </linearGradient>
          </defs>
        </svg>
      )}
      {variant === ShampooIconVariant.NEWBIE_4 && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.51044 3.23247C9.51044 2.89697 9.78241 2.625 10.1179 2.625H15.251H15.4442L17.0162 3.73695C17.2902 3.93069 17.3551 4.30978 17.1614 4.58369C16.9677 4.8576 16.5886 4.92259 16.3147 4.72885L15.0579 3.83994H12.5674V5.08712H13.6771C13.9902 5.08712 14.2441 5.34096 14.2441 5.65409V6.73068C16.5691 7.29688 18.2951 9.3931 18.2951 11.8924V18.2504C18.2951 19.9762 16.896 21.3753 15.1701 21.3753H8.74995C7.02409 21.3753 5.625 19.9762 5.625 18.2504V11.8924C5.625 9.38028 7.36872 7.27539 9.71185 6.72209V5.65409C9.71185 5.34096 9.9657 5.08712 10.2788 5.08712H11.3525V3.83994H10.1179C9.78241 3.83994 9.51044 3.56797 9.51044 3.23247Z"
            fill="url(#paint0_linear_2537_82587)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.6428 2L17.3771 3.22669C17.9329 3.61975 18.0647 4.38888 17.6717 4.94459C17.2786 5.5003 16.5095 5.63216 15.9537 5.2391L14.8592 4.46492H13.7594C14.3793 4.50722 14.8691 5.02346 14.8691 5.65409V6.26114C17.2232 7.04951 18.9201 9.27213 18.9201 11.8924V18.2504C18.9201 20.3214 17.2412 22.0003 15.1701 22.0003H8.74995C6.67891 22.0003 5 20.3214 5 18.2504V11.8924C5 9.25889 6.71406 7.02702 9.08685 6.24927V5.65409C9.08685 5.02346 9.57658 4.50722 10.1965 4.46492H10.1179C9.43723 4.46492 8.88544 3.91313 8.88544 3.23246C8.88544 2.55179 9.43723 2 10.1179 2H15.6428ZM11.3524 3.83993V5.08711H10.2788C9.96569 5.08711 9.71185 5.34096 9.71185 5.65409V6.72208C7.36871 7.27538 5.62499 9.38027 5.62499 11.8924V18.2504C5.62499 19.9762 7.02408 21.3753 8.74995 21.3753H15.1701C16.896 21.3753 18.2951 19.9762 18.2951 18.2504V11.8924C18.2951 9.39309 16.5691 7.29688 14.2441 6.73067V5.65409C14.2441 5.34096 13.9902 5.08711 13.6771 5.08711H12.5674V3.83993H15.0579L16.3147 4.72884C16.5886 4.92258 16.9677 4.85759 17.1614 4.58368C17.3551 4.30978 17.2901 3.93068 17.0162 3.73694L15.4441 2.62499H10.1179C9.78241 2.62499 9.51043 2.89696 9.51043 3.23246C9.51043 3.56796 9.78241 3.83993 10.1179 3.83993H11.3524Z"
            fill="#EA5200"
          />
          <path
            d="M14.4678 11.45C14.8644 11.45 15.1876 11.7713 15.1876 12.1698C15.1876 12.5664 14.8644 12.8895 14.4678 12.8895C14.0712 12.8895 13.748 12.5664 13.748 12.1698C13.748 11.7731 14.0712 11.45 14.4678 11.45Z"
            fill="#D30700"
          />
          <path
            d="M9.45124 11.45C9.84787 11.45 10.171 11.7713 10.171 12.1698C10.171 12.5664 9.84787 12.8895 9.45124 12.8895C9.05462 12.8895 8.73145 12.5664 8.73145 12.1698C8.73145 11.7731 9.05462 11.45 9.45124 11.45Z"
            fill="#D30700"
          />
          <path
            d="M12.8905 12.3497C12.8905 12.8657 12.4718 13.2862 11.954 13.2862H11.9522C11.4362 13.2862 11.0157 12.8675 11.0157 12.3497H12.8905Z"
            fill="#D30700"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2537_82587"
              x1="5.625"
              y1="2.625"
              x2="18.7237"
              y2="21.673"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFF260" />
              <stop offset="1" stopColor="#FFB746" />
            </linearGradient>
          </defs>
        </svg>
      )}
      {variant === ShampooIconVariant.NEWBIE_3 && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.51044 3.23247C9.51044 2.89697 9.78241 2.625 10.1179 2.625H15.251H15.4442L17.0162 3.73695C17.2902 3.93069 17.3551 4.30978 17.1614 4.58369C16.9677 4.8576 16.5886 4.92259 16.3147 4.72885L15.0579 3.83994H12.5674V5.08712H13.6771C13.9902 5.08712 14.2441 5.34096 14.2441 5.65409V6.73068C16.5691 7.29688 18.2951 9.3931 18.2951 11.8924V18.2504C18.2951 19.9762 16.896 21.3753 15.1701 21.3753H8.74995C7.02409 21.3753 5.625 19.9762 5.625 18.2504V11.8924C5.625 9.38028 7.36872 7.27539 9.71185 6.72209V5.65409C9.71185 5.34096 9.9657 5.08712 10.2788 5.08712H11.3525V3.83994H10.1179C9.78241 3.83994 9.51044 3.56797 9.51044 3.23247Z"
            fill="url(#paint0_linear_2537_82604)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.6428 2L17.3771 3.22669C17.9329 3.61975 18.0647 4.38888 17.6717 4.94459C17.2786 5.5003 16.5095 5.63216 15.9537 5.2391L14.8592 4.46492H13.7594C14.3793 4.50722 14.8691 5.02346 14.8691 5.65409V6.26114C17.2232 7.04951 18.9201 9.27213 18.9201 11.8924V18.2504C18.9201 20.3214 17.2412 22.0003 15.1701 22.0003H8.74995C6.67891 22.0003 5 20.3214 5 18.2504V11.8924C5 9.25889 6.71406 7.02702 9.08685 6.24927V5.65409C9.08685 5.02346 9.57658 4.50722 10.1965 4.46492H10.1179C9.43723 4.46492 8.88544 3.91313 8.88544 3.23246C8.88544 2.55179 9.43723 2 10.1179 2H15.6428ZM11.3524 3.83993V5.08711H10.2788C9.96569 5.08711 9.71185 5.34096 9.71185 5.65409V6.72208C7.36871 7.27538 5.62499 9.38027 5.62499 11.8924V18.2504C5.62499 19.9762 7.02408 21.3753 8.74995 21.3753H15.1701C16.896 21.3753 18.2951 19.9762 18.2951 18.2504V11.8924C18.2951 9.39309 16.5691 7.29688 14.2441 6.73067V5.65409C14.2441 5.34096 13.9902 5.08711 13.6771 5.08711H12.5674V3.83993H15.0579L16.3147 4.72884C16.5886 4.92258 16.9677 4.85759 17.1614 4.58368C17.3551 4.30978 17.2901 3.93068 17.0162 3.73694L15.4441 2.62499H10.1179C9.78241 2.62499 9.51043 2.89696 9.51043 3.23246C9.51043 3.56796 9.78241 3.83993 10.1179 3.83993H11.3524Z"
            fill="#EA5200"
          />
          <mask
            id="mask0_2537_82604"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="5"
            y="2"
            width="14"
            height="20"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.51044 3.23247C9.51044 2.89697 9.78241 2.625 10.1179 2.625H15.251H15.4442L17.0162 3.73695C17.2902 3.93069 17.3551 4.30978 17.1614 4.58369C16.9677 4.8576 16.5886 4.92259 16.3147 4.72885L15.0579 3.83994H12.5674V5.08712H13.6771C13.9902 5.08712 14.2441 5.34096 14.2441 5.65409V6.73068C16.5691 7.29688 18.2951 9.3931 18.2951 11.8924V18.2504C18.2951 19.9762 16.896 21.3753 15.1701 21.3753H8.74995C7.02409 21.3753 5.625 19.9762 5.625 18.2504V11.8924C5.625 9.38028 7.36872 7.27539 9.71185 6.72209V5.65409C9.71185 5.34096 9.9657 5.08712 10.2788 5.08712H11.3525V3.83994H10.1179C9.78241 3.83994 9.51044 3.56797 9.51044 3.23247Z"
              fill="#FFF6E8"
            />
          </mask>
          <g mask="url(#mask0_2537_82604)">
            <path d="M5.625 2.17505H18.2951V7.50366H5.625V2.17505Z" fill="#FFF6E8" />
          </g>
          <path
            d="M14.4678 11.45C14.8644 11.45 15.1876 11.7713 15.1876 12.1698C15.1876 12.5664 14.8644 12.8895 14.4678 12.8895C14.0712 12.8895 13.748 12.5664 13.748 12.1698C13.748 11.7731 14.0712 11.45 14.4678 11.45Z"
            fill="#D30700"
          />
          <path
            d="M9.45124 11.45C9.84787 11.45 10.171 11.7713 10.171 12.1698C10.171 12.5664 9.84787 12.8895 9.45124 12.8895C9.05462 12.8895 8.73145 12.5664 8.73145 12.1698C8.73145 11.7731 9.05462 11.45 9.45124 11.45Z"
            fill="#D30700"
          />
          <path
            d="M12.8905 12.3497C12.8905 12.8657 12.4718 13.2862 11.954 13.2862H11.9522C11.4362 13.2862 11.0157 12.8675 11.0157 12.3497H12.8905Z"
            fill="#D30700"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2537_82604"
              x1="5.625"
              y1="2.625"
              x2="18.7237"
              y2="21.673"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFF260" />
              <stop offset="1" stopColor="#FFB746" />
            </linearGradient>
          </defs>
        </svg>
      )}
      {variant === ShampooIconVariant.NEWBIE_2 && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.51044 3.23247C9.51044 2.89697 9.78241 2.625 10.1179 2.625H15.251H15.4442L17.0162 3.73695C17.2902 3.93069 17.3551 4.30978 17.1614 4.58369C16.9677 4.8576 16.5886 4.92259 16.3147 4.72885L15.0579 3.83994H12.5674V5.08712H13.6771C13.9902 5.08712 14.2441 5.34096 14.2441 5.65409V6.73068C16.5691 7.29688 18.2951 9.3931 18.2951 11.8924V18.2504C18.2951 19.9762 16.896 21.3753 15.1701 21.3753H8.74995C7.02409 21.3753 5.625 19.9762 5.625 18.2504V11.8924C5.625 9.38028 7.36872 7.27539 9.71185 6.72209V5.65409C9.71185 5.34096 9.9657 5.08712 10.2788 5.08712H11.3525V3.83994H10.1179C9.78241 3.83994 9.51044 3.56797 9.51044 3.23247Z"
            fill="url(#paint0_linear_2537_82621)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.6428 2L17.3771 3.22669C17.9329 3.61975 18.0647 4.38888 17.6717 4.94459C17.2786 5.5003 16.5095 5.63216 15.9537 5.2391L14.8592 4.46492H13.7594C14.3793 4.50722 14.8691 5.02346 14.8691 5.65409V6.26114C17.2232 7.04951 18.9201 9.27213 18.9201 11.8924V18.2504C18.9201 20.3214 17.2412 22.0003 15.1701 22.0003H8.74995C6.67891 22.0003 5 20.3214 5 18.2504V11.8924C5 9.25889 6.71406 7.02702 9.08685 6.24927V5.65409C9.08685 5.02346 9.57658 4.50722 10.1965 4.46492H10.1179C9.43723 4.46492 8.88544 3.91313 8.88544 3.23246C8.88544 2.55179 9.43723 2 10.1179 2H15.6428ZM11.3524 3.83993V5.08711H10.2788C9.96569 5.08711 9.71185 5.34096 9.71185 5.65409V6.72208C7.36871 7.27538 5.62499 9.38027 5.62499 11.8924V18.2504C5.62499 19.9762 7.02408 21.3753 8.74995 21.3753H15.1701C16.896 21.3753 18.2951 19.9762 18.2951 18.2504V11.8924C18.2951 9.39309 16.5691 7.29688 14.2441 6.73067V5.65409C14.2441 5.34096 13.9902 5.08711 13.6771 5.08711H12.5674V3.83993H15.0579L16.3147 4.72884C16.5886 4.92258 16.9677 4.85759 17.1614 4.58368C17.3551 4.30978 17.2901 3.93068 17.0162 3.73694L15.4441 2.62499H10.1179C9.78241 2.62499 9.51043 2.89696 9.51043 3.23246C9.51043 3.56796 9.78241 3.83993 10.1179 3.83993H11.3524Z"
            fill="#EA5200"
          />
          <mask
            id="mask0_2537_82621"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="5"
            y="2"
            width="14"
            height="20"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.51044 3.23247C9.51044 2.89697 9.78241 2.625 10.1179 2.625H15.251H15.4442L17.0162 3.73695C17.2902 3.93069 17.3551 4.30978 17.1614 4.58369C16.9677 4.8576 16.5886 4.92259 16.3147 4.72885L15.0579 3.83994H12.5674V5.08712H13.6771C13.9902 5.08712 14.2441 5.34096 14.2441 5.65409V6.73068C16.5691 7.29688 18.2951 9.3931 18.2951 11.8924V18.2504C18.2951 19.9762 16.896 21.3753 15.1701 21.3753H8.74995C7.02409 21.3753 5.625 19.9762 5.625 18.2504V11.8924C5.625 9.38028 7.36872 7.27539 9.71185 6.72209V5.65409C9.71185 5.34096 9.9657 5.08712 10.2788 5.08712H11.3525V3.83994H10.1179C9.78241 3.83994 9.51044 3.56797 9.51044 3.23247Z"
              fill="#FFF6E8"
            />
          </mask>
          <g mask="url(#mask0_2537_82621)">
            <path d="M5.625 2.17505H18.2951V13.9377H5.625V2.17505Z" fill="#FFF6E8" />
          </g>
          <path
            d="M14.4678 11.45C14.8644 11.45 15.1876 11.7713 15.1876 12.1698C15.1876 12.5664 14.8644 12.8895 14.4678 12.8895C14.0712 12.8895 13.748 12.5664 13.748 12.1698C13.748 11.7731 14.0712 11.45 14.4678 11.45Z"
            fill="#D30700"
          />
          <path
            d="M9.45124 11.45C9.84787 11.45 10.171 11.7713 10.171 12.1698C10.171 12.5664 9.84787 12.8895 9.45124 12.8895C9.05462 12.8895 8.73145 12.5664 8.73145 12.1698C8.73145 11.7731 9.05462 11.45 9.45124 11.45Z"
            fill="#D30700"
          />
          <path
            d="M12.8905 12.3497C12.8905 12.8657 12.4718 13.2862 11.954 13.2862H11.9522C11.4362 13.2862 11.0157 12.8675 11.0157 12.3497H12.8905Z"
            fill="#D30700"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2537_82621"
              x1="5.625"
              y1="2.625"
              x2="18.7237"
              y2="21.673"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFF260" />
              <stop offset="1" stopColor="#FFB746" />
            </linearGradient>
          </defs>
        </svg>
      )}
      {variant === ShampooIconVariant.NEWBIE_1 && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.51044 3.23247C9.51044 2.89697 9.78241 2.625 10.1179 2.625H15.251H15.4442L17.0162 3.73695C17.2902 3.93069 17.3551 4.30978 17.1614 4.58369C16.9677 4.8576 16.5886 4.92259 16.3147 4.72885L15.0579 3.83994H12.5674V5.08712H13.6771C13.9902 5.08712 14.2441 5.34096 14.2441 5.65409V6.73068C16.5691 7.29688 18.2951 9.3931 18.2951 11.8924V18.2504C18.2951 19.9762 16.896 21.3753 15.1701 21.3753H8.74995C7.02409 21.3753 5.625 19.9762 5.625 18.2504V11.8924C5.625 9.38028 7.36872 7.27539 9.71185 6.72209V5.65409C9.71185 5.34096 9.9657 5.08712 10.2788 5.08712H11.3525V3.83994H10.1179C9.78241 3.83994 9.51044 3.56797 9.51044 3.23247Z"
            fill="url(#paint0_linear_2537_82638)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.6428 2L17.3771 3.22669C17.9329 3.61975 18.0647 4.38888 17.6717 4.94459C17.2786 5.5003 16.5095 5.63216 15.9537 5.2391L14.8592 4.46492H13.7594C14.3793 4.50722 14.8691 5.02346 14.8691 5.65409V6.26114C17.2232 7.04951 18.9201 9.27213 18.9201 11.8924V18.2504C18.9201 20.3214 17.2412 22.0003 15.1701 22.0003H8.74995C6.67891 22.0003 5 20.3214 5 18.2504V11.8924C5 9.25889 6.71406 7.02702 9.08685 6.24927V5.65409C9.08685 5.02346 9.57658 4.50722 10.1965 4.46492H10.1179C9.43723 4.46492 8.88544 3.91313 8.88544 3.23246C8.88544 2.55179 9.43723 2 10.1179 2H15.6428ZM11.3524 3.83993V5.08711H10.2788C9.96569 5.08711 9.71185 5.34096 9.71185 5.65409V6.72208C7.36871 7.27538 5.62499 9.38027 5.62499 11.8924V18.2504C5.62499 19.9762 7.02408 21.3753 8.74995 21.3753H15.1701C16.896 21.3753 18.2951 19.9762 18.2951 18.2504V11.8924C18.2951 9.39309 16.5691 7.29688 14.2441 6.73067V5.65409C14.2441 5.34096 13.9902 5.08711 13.6771 5.08711H12.5674V3.83993H15.0579L16.3147 4.72884C16.5886 4.92258 16.9677 4.85759 17.1614 4.58368C17.3551 4.30978 17.2901 3.93068 17.0162 3.73694L15.4441 2.62499H10.1179C9.78241 2.62499 9.51043 2.89696 9.51043 3.23246C9.51043 3.56796 9.78241 3.83993 10.1179 3.83993H11.3524Z"
            fill="#EA5200"
          />
          <mask
            id="mask0_2537_82638"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="5"
            y="2"
            width="14"
            height="20"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.51044 3.23247C9.51044 2.89697 9.78241 2.625 10.1179 2.625H15.251H15.4442L17.0162 3.73695C17.2902 3.93069 17.3551 4.30978 17.1614 4.58369C16.9677 4.8576 16.5886 4.92259 16.3147 4.72885L15.0579 3.83994H12.5674V5.08712H13.6771C13.9902 5.08712 14.2441 5.34096 14.2441 5.65409V6.73068C16.5691 7.29688 18.2951 9.3931 18.2951 11.8924V18.2504C18.2951 19.9762 16.896 21.3753 15.1701 21.3753H8.74995C7.02409 21.3753 5.625 19.9762 5.625 18.2504V11.8924C5.625 9.38028 7.36872 7.27539 9.71185 6.72209V5.65409C9.71185 5.34096 9.9657 5.08712 10.2788 5.08712H11.3525V3.83994H10.1179C9.78241 3.83994 9.51044 3.56797 9.51044 3.23247Z"
              fill="#FFF6E8"
            />
          </mask>
          <g mask="url(#mask0_2537_82638)">
            <path d="M5.625 2.17505H18.2951V18.2014H5.625V2.17505Z" fill="#FFF6E8" />
          </g>
          <path
            d="M14.4678 11.45C14.8644 11.45 15.1876 11.7713 15.1876 12.1698C15.1876 12.5664 14.8644 12.8895 14.4678 12.8895C14.0712 12.8895 13.748 12.5664 13.748 12.1698C13.748 11.7731 14.0712 11.45 14.4678 11.45Z"
            fill="#D30700"
          />
          <path
            d="M9.45124 11.45C9.84787 11.45 10.171 11.7713 10.171 12.1698C10.171 12.5664 9.84787 12.8895 9.45124 12.8895C9.05462 12.8895 8.73145 12.5664 8.73145 12.1698C8.73145 11.7731 9.05462 11.45 9.45124 11.45Z"
            fill="#D30700"
          />
          <path
            d="M12.8905 12.3497C12.8905 12.8657 12.4718 13.2862 11.954 13.2862H11.9522C11.4362 13.2862 11.0157 12.8675 11.0157 12.3497H12.8905Z"
            fill="#D30700"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2537_82638"
              x1="5.625"
              y1="2.625"
              x2="18.7237"
              y2="21.673"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFF260" />
              <stop offset="1" stopColor="#FFB746" />
            </linearGradient>
          </defs>
        </svg>
      )}
      {variant === ShampooIconVariant.NEWBIE_0 && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.51044 3.23247C9.51044 2.89697 9.78241 2.625 10.1179 2.625H15.251H15.4442L17.0162 3.73695C17.2902 3.93069 17.3551 4.30978 17.1614 4.58369C16.9677 4.8576 16.5886 4.92259 16.3147 4.72885L15.0579 3.83994H12.5674V5.08712H13.6771C13.9902 5.08712 14.2441 5.34096 14.2441 5.65409V6.73068C16.5691 7.29688 18.2951 9.3931 18.2951 11.8924V18.2504C18.2951 19.9762 16.896 21.3753 15.1701 21.3753H8.74995C7.02409 21.3753 5.625 19.9762 5.625 18.2504V11.8924C5.625 9.38028 7.36872 7.27539 9.71185 6.72209V5.65409C9.71185 5.34096 9.9657 5.08712 10.2788 5.08712H11.3525V3.83994H10.1179C9.78241 3.83994 9.51044 3.56797 9.51044 3.23247Z"
            fill="url(#paint0_linear_2537_82641)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.6428 2L17.3771 3.22669C17.9329 3.61975 18.0647 4.38888 17.6717 4.94459C17.2786 5.5003 16.5095 5.63216 15.9537 5.2391L14.8592 4.46492H13.7594C14.3793 4.50722 14.8691 5.02346 14.8691 5.65409V6.26114C17.2232 7.04951 18.9201 9.27213 18.9201 11.8924V18.2504C18.9201 20.3214 17.2412 22.0003 15.1701 22.0003H8.74995C6.67891 22.0003 5 20.3214 5 18.2504V11.8924C5 9.25889 6.71406 7.02702 9.08685 6.24927V5.65409C9.08685 5.02346 9.57658 4.50722 10.1965 4.46492H10.1179C9.43723 4.46492 8.88544 3.91313 8.88544 3.23246C8.88544 2.55179 9.43723 2 10.1179 2H15.6428ZM11.3524 3.83993V5.08711H10.2788C9.96569 5.08711 9.71185 5.34096 9.71185 5.65409V6.72208C7.36871 7.27538 5.62499 9.38027 5.62499 11.8924V18.2504C5.62499 19.9762 7.02408 21.3753 8.74995 21.3753H15.1701C16.896 21.3753 18.2951 19.9762 18.2951 18.2504V11.8924C18.2951 9.39309 16.5691 7.29688 14.2441 6.73067V5.65409C14.2441 5.34096 13.9902 5.08711 13.6771 5.08711H12.5674V3.83993H15.0579L16.3147 4.72884C16.5886 4.92258 16.9677 4.85759 17.1614 4.58368C17.3551 4.30978 17.2901 3.93068 17.0162 3.73694L15.4441 2.62499H10.1179C9.78241 2.62499 9.51043 2.89696 9.51043 3.23246C9.51043 3.56796 9.78241 3.83993 10.1179 3.83993H11.3524Z"
            fill="#EA5200"
          />
          <mask
            id="mask0_2537_82641"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="5"
            y="2"
            width="14"
            height="20"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.51044 3.23247C9.51044 2.89697 9.78241 2.625 10.1179 2.625H15.251H15.4442L17.0162 3.73695C17.2902 3.93069 17.3551 4.30978 17.1614 4.58369C16.9677 4.8576 16.5886 4.92259 16.3147 4.72885L15.0579 3.83994H12.5674V5.08712H13.6771C13.9902 5.08712 14.2441 5.34096 14.2441 5.65409V6.73068C16.5691 7.29688 18.2951 9.3931 18.2951 11.8924V18.2504C18.2951 19.9762 16.896 21.3753 15.1701 21.3753H8.74995C7.02409 21.3753 5.625 19.9762 5.625 18.2504V11.8924C5.625 9.38028 7.36872 7.27539 9.71185 6.72209V5.65409C9.71185 5.34096 9.9657 5.08712 10.2788 5.08712H11.3525V3.83994H10.1179C9.78241 3.83994 9.51044 3.56797 9.51044 3.23247Z"
              fill="#FFF6E8"
            />
          </mask>
          <g mask="url(#mask0_2537_82641)">
            <path d="M5 2H18.9199V22H5V2Z" fill="#FFF6E8" />
          </g>
          <path
            d="M11.0287 13.2598C11.0287 12.7507 11.4474 12.3357 11.9652 12.3357H11.967C12.483 12.3357 12.9035 12.7489 12.9035 13.2598L11.0287 13.2598Z"
            fill="#D30700"
          />
          <path
            d="M14.4678 11.4224C14.8644 11.4224 15.1876 11.7395 15.1876 12.1326C15.1876 12.524 14.8644 12.8429 14.4678 12.8429C14.0712 12.8429 13.748 12.524 13.748 12.1326C13.748 11.7413 14.0712 11.4224 14.4678 11.4224Z"
            fill="#D30700"
          />
          <path
            d="M9.45124 11.4224C9.84787 11.4224 10.171 11.7395 10.171 12.1326C10.171 12.524 9.84787 12.8429 9.45124 12.8429C9.05462 12.8429 8.73145 12.524 8.73145 12.1326C8.73145 11.7413 9.05462 11.4224 9.45124 11.4224Z"
            fill="#D30700"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2537_82641"
              x1="5.625"
              y1="2.625"
              x2="18.7237"
              y2="21.673"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFF260" />
              <stop offset="1" stopColor="#FFB746" />
            </linearGradient>
          </defs>
        </svg>
      )}
      {variant === ShampooIconVariant.ERROR && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.7459 2L17.4794 3.22669C18.0348 3.61975 18.1666 4.38888 17.7738 4.94459C17.3809 5.5003 16.6121 5.63216 16.0567 5.2391L14.9626 4.46492H13.8634C14.483 4.50722 14.9725 5.02346 14.9725 5.65409V6.15971C16.7281 6.71944 17.9998 8.3635 17.9998 10.3058V19.1875C17.9998 20.7408 16.7412 22 15.1886 22H8.81113C7.25858 22 6 20.7408 6 19.1875V10.3058C6 8.30304 7.3521 6.61711 9.19302 6.11049V5.65409C9.19302 5.02346 9.68252 4.50722 10.3021 4.46492H10.2236C9.54323 4.46492 8.9917 3.91313 8.9917 3.23246C8.9917 2.55179 9.54323 2 10.2236 2H15.7459ZM11.4575 3.83993V5.08711H10.3844C10.0714 5.08711 9.81772 5.34096 9.81772 5.65409V6.6176C8.01251 6.87545 6.62469 8.42849 6.62469 10.3058V19.1875C6.62469 20.3956 7.60359 21.375 8.81113 21.375H15.1886C16.3962 21.375 17.3751 20.3956 17.3751 19.1875V10.3058C17.3751 8.48637 16.0715 6.97152 14.3478 6.64512V5.65409C14.3478 5.34096 14.0941 5.08711 13.7811 5.08711H12.6719V3.83993H15.1612L16.4174 4.72884C16.6912 4.92258 17.0701 4.85759 17.2637 4.58368C17.4574 4.30978 17.3924 3.93068 17.1186 3.73694L15.5473 2.62499H10.2236C9.88824 2.62499 9.6164 2.89696 9.6164 3.23246C9.6164 3.56796 9.88824 3.83993 10.2236 3.83993H11.4575Z"
            fill="#A9005C"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.6167 3.23247C9.6167 2.89697 9.88855 2.625 10.2239 2.625H15.3545H15.5476L17.1189 3.73695C17.3927 3.93069 17.4577 4.30978 17.264 4.58369C17.0704 4.8576 16.6915 4.92259 16.4177 4.72885L15.1615 3.83994H12.6722V5.08712H13.7814C14.0944 5.08712 14.3481 5.34096 14.3481 5.65409V6.64513C16.0718 6.97153 17.3754 8.48638 17.3754 10.3058V19.1876C17.3754 20.3957 16.3965 21.375 15.1889 21.375H8.81143C7.6039 21.375 6.625 20.3957 6.625 19.1875V10.3058C6.625 8.4285 8.01282 6.87546 9.81802 6.61761V5.65409C9.81802 5.34096 10.0717 5.08712 10.3847 5.08712H11.4578V3.83994H10.2239C9.88855 3.83994 9.6167 3.56797 9.6167 3.23247ZM11.9999 15.25C12.5522 15.25 12.9999 14.8023 12.9999 14.25V9.25C12.9999 8.69772 12.5522 8.25 11.9999 8.25C11.4476 8.25 10.9999 8.69772 10.9999 9.25V14.25C10.9999 14.8023 11.4476 15.25 11.9999 15.25ZM12.0022 16.5C12.6926 16.5 13.2522 17.0596 13.2522 17.75C13.2522 18.4404 12.6926 19 12.0022 19C11.3119 19 10.7522 18.4404 10.7522 17.75C10.7522 17.0596 11.3119 16.5 12.0022 16.5Z"
            fill="#FE008A"
          />
        </svg>
      )}
      {variant === ShampooIconVariant.LOADING && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.7459 2.03125L17.4794 3.25794C18.0348 3.651 18.1666 4.42013 17.7738 4.97584C17.3809 5.53155 16.6121 5.66341 16.0567 5.27035L14.9626 4.49617H13.8634C14.483 4.53847 14.9725 5.05471 14.9725 5.68534V6.19096C16.7281 6.75069 17.9998 8.39475 17.9998 10.3371V19.2188C17.9998 20.7721 16.7412 22.0312 15.1886 22.0312H8.81113C7.25858 22.0312 6 20.7721 6 19.2188V10.3371C6 8.33429 7.3521 6.64836 9.19302 6.14174V5.68534C9.19302 5.05471 9.68252 4.53847 10.3021 4.49617H10.2236C9.54323 4.49617 8.9917 3.94438 8.9917 3.26371C8.9917 2.58304 9.54323 2.03125 10.2236 2.03125H15.7459ZM11.4575 3.87118V5.11836H10.3844C10.0714 5.11836 9.81772 5.37221 9.81772 5.68534V6.64885C8.01251 6.9067 6.62469 8.45974 6.62469 10.3371V19.2188C6.62469 20.4269 7.60359 21.4063 8.81113 21.4063H15.1886C16.3962 21.4063 17.3751 20.4269 17.3751 19.2188V10.3371C17.3751 8.51762 16.0715 7.00277 14.3478 6.67637V5.68534C14.3478 5.37221 14.0941 5.11836 13.7811 5.11836H12.6719V3.87118H15.1612L16.4174 4.76009C16.6912 4.95383 17.0701 4.88884 17.2637 4.61493C17.4574 4.34103 17.3924 3.96193 17.1186 3.76819L15.5473 2.65624H10.2236C9.88824 2.65624 9.6164 2.92821 9.6164 3.26371C9.6164 3.59921 9.88824 3.87118 10.2236 3.87118H11.4575Z"
            fill="#606064"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.6167 3.26372C9.6167 2.92822 9.88855 2.65625 10.2239 2.65625H15.3545H15.5476L17.1189 3.7682C17.3927 3.96194 17.4577 4.34103 17.264 4.61494C17.0704 4.88885 16.6915 4.95384 16.4177 4.7601L15.1615 3.87119H12.6722V5.11837H13.7814C14.0944 5.11837 14.3481 5.37221 14.3481 5.68534V6.67638C16.0718 7.00278 17.3754 8.51763 17.3754 10.3371V19.2188C17.3754 20.4269 16.3965 21.4063 15.1889 21.4063H8.81143C7.6039 21.4063 6.625 20.4269 6.625 19.2188V10.3371C6.625 8.45975 8.01282 6.90671 9.81802 6.64886V5.68534C9.81802 5.37221 10.0717 5.11837 10.3847 5.11837H11.4578V3.87119H10.2239C9.88855 3.87119 9.6167 3.59922 9.6167 3.26372Z"
            fill="#EAEAEC"
          />
          <g opacity="0.8">
            <path
              opacity="0.3"
              d="M9.58147 11.1996C9.47297 11.1996 9.36892 11.2427 9.2922 11.3194C9.21548 11.3961 9.17238 11.5001 9.17238 11.6086C9.17238 11.7171 9.21548 11.8212 9.2922 11.8979L10.16 12.7657C10.2367 12.8424 10.3408 12.8855 10.4493 12.8855C10.5578 12.8855 10.6618 12.8424 10.7386 12.7657C10.8153 12.689 10.8584 12.585 10.8584 12.4765C10.8584 12.368 10.8153 12.2639 10.7386 12.1872L9.87074 11.3194C9.79402 11.2427 9.68997 11.1996 9.58147 11.1996Z"
              fill="#636363"
            />
            <path
              opacity="0.9"
              d="M13.558 15.177C13.4495 15.177 13.3455 15.2201 13.2688 15.2968C13.192 15.3735 13.1489 15.4776 13.1489 15.5861C13.1489 15.6946 13.192 15.7986 13.2688 15.8753L14.1366 16.7431C14.2133 16.8199 14.3173 16.863 14.4258 16.863C14.5343 16.863 14.6384 16.8199 14.7151 16.7431C14.7918 16.6664 14.8349 16.5624 14.8349 16.4539C14.8349 16.3454 14.7918 16.2413 14.7151 16.1646L13.8473 15.2968C13.7706 15.2201 13.6665 15.177 13.558 15.177Z"
              fill="#636363"
            />
            <path
              opacity="0.7"
              d="M9.17099 16.4538C9.17099 16.5623 9.21409 16.6664 9.29081 16.7431C9.36753 16.8198 9.47158 16.8629 9.58008 16.8629C9.68858 16.8629 9.79263 16.8198 9.86935 16.7431L10.7372 15.8753C10.8139 15.7985 10.857 15.6945 10.857 15.586C10.857 15.4775 10.8139 15.3734 10.7372 15.2967C10.6604 15.22 10.5564 15.1769 10.4479 15.1769C10.3394 15.1769 10.2353 15.22 10.1586 15.2967L9.29081 16.1645C9.21409 16.2413 9.17099 16.3453 9.17099 16.4538Z"
              fill="#636363"
            />
            <path
              d="M13.1505 12.4763C13.1505 12.5848 13.1936 12.6888 13.2703 12.7655C13.347 12.8423 13.4511 12.8854 13.5596 12.8854C13.6681 12.8854 13.7721 12.8423 13.8488 12.7655L14.7167 11.8977C14.7934 11.821 14.8365 11.717 14.8365 11.6085C14.8365 11.5 14.7934 11.3959 14.7167 11.3192C14.6399 11.2425 14.5359 11.1994 14.4274 11.1994C14.3189 11.1994 14.2148 11.2425 14.1381 11.3192L13.2703 12.187C13.1936 12.2637 13.1505 12.3678 13.1505 12.4763Z"
              fill="#636363"
            />
            <path
              opacity="0.5"
              d="M8.28974 13.7419C8.21302 13.8187 8.16992 13.9227 8.16992 14.0312C8.16992 14.1397 8.21302 14.2438 8.28974 14.3205C8.36646 14.3972 8.47052 14.4403 8.57901 14.4403L9.80629 14.4403C9.91478 14.4403 10.0188 14.3972 10.0956 14.3205C10.1723 14.2438 10.2154 14.1397 10.2154 14.0312C10.2154 13.9227 10.1723 13.8187 10.0956 13.7419C10.0188 13.6652 9.91478 13.6221 9.80629 13.6221L8.57901 13.6221C8.47052 13.6221 8.36646 13.6652 8.28974 13.7419Z"
              fill="#636363"
            />
            <path
              d="M13.9147 13.7419C13.838 13.8187 13.7949 13.9227 13.7949 14.0312C13.7949 14.1397 13.838 14.2438 13.9147 14.3205C13.9915 14.3972 14.0955 14.4403 14.204 14.4403L15.4313 14.4403C15.5398 14.4403 15.6438 14.3972 15.7206 14.3205C15.7973 14.2438 15.8404 14.1397 15.8404 14.0312C15.8404 13.9227 15.7973 13.8187 15.7206 13.7419C15.6438 13.6652 15.5398 13.6221 15.4313 13.6221L14.204 13.6221C14.0955 13.6221 13.9915 13.6652 13.9147 13.7419Z"
              fill="#636363"
            />
            <path
              opacity="0.8"
              d="M11.7137 17.7466C11.7905 17.8234 11.8945 17.8665 12.003 17.8665C12.1115 17.8665 12.2156 17.8234 12.2923 17.7466C12.369 17.6699 12.4121 17.5659 12.4121 17.4574L12.4121 16.2301C12.4121 16.1216 12.369 16.0175 12.2923 15.9408C12.2156 15.8641 12.1115 15.821 12.003 15.821C11.8945 15.821 11.7905 15.8641 11.7137 15.9408C11.637 16.0175 11.5939 16.1216 11.5939 16.2301L11.5939 17.4574C11.5939 17.5659 11.637 17.6699 11.7137 17.7466Z"
              fill="#636363"
            />
            <path
              opacity="0.2"
              d="M11.7137 12.1216C11.7905 12.1984 11.8945 12.2415 12.003 12.2415C12.1115 12.2415 12.2156 12.1984 12.2923 12.1216C12.369 12.0449 12.4121 11.9409 12.4121 11.8324L12.4121 10.6051C12.4121 10.4966 12.369 10.3925 12.2923 10.3158C12.2156 10.2391 12.1115 10.196 12.003 10.196C11.8945 10.196 11.7905 10.2391 11.7137 10.3158C11.637 10.3925 11.5939 10.4966 11.5939 10.6051L11.5939 11.8324C11.5939 11.9409 11.637 12.0449 11.7137 12.1216Z"
              fill="#636363"
            />
          </g>
        </svg>
      )}
    </i>
  );
}

export default ShampooIcon;
